import { render, staticRenderFns } from "./Flex.vue?vue&type=template&id=8703ee0a&scoped=true"
import script from "./Flex.vue?vue&type=script&lang=js"
export * from "./Flex.vue?vue&type=script&lang=js"
import style0 from "./Flex.vue?vue&type=style&index=0&id=8703ee0a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8703ee0a",
  null
  
)

export default component.exports